import React, { Suspense, useEffect, useState } from "react";
import { Carousel } from "antd";
import VideoPlayer from "./VideoPlayer";
import GameStep from "./GameStep/GameStep";
import SurvivalTable from "./GameStep/SurvivalTable";
import JoinGame from "./JoinGame/JoinGame";
import { useNavigate, useLocation } from "react-router-dom";
import { setNavItem } from "../../../utils/localStorage";
import HomeStep2 from "../../../assets/images/step_2.png";
// Panel 01 has no image for now: the old step_1.png (£ pot table) was
// rejected, and staging has no reachable joinable game to capture a real
// replacement from outside the BetArabia iFrame (CORS blocks the API for
// any origin other than the live iFrame session). See qa report for the
// exact capture spec needed to restore an image here.
import { useScreenWidth } from "../../../utils/useScreenWidth";
import IntroVideo from "../../../assets/videos/intro-video.mp4";
import { useMyContext } from "../../../helpers/Context/MyContext";
import { getToken, getAccountId, getGameId } from "../../../utils/localStorage";

import {
  BannerPromo,
  FilledButton,
  HomeNews,
  SimpleFilledButton,
} from "../../commonComponents";
import { sendMetaEvents } from "../../../helpers/genericFunctions";
import {
  getPublicGamesForPublic,
  getPublicGamesForUser,
} from "../../../utils/service";
import "./Home.scss";
import Loading from "../../commonComponents/Loading/Loading";
import {
  setToken,
  setAccountId,
  setGameId,
  setOperator,
  setGameServer,
  setCurrency,
  setGameMode,
  setJurisdiction,
  setLocale,
} from "../../../utils/localStorage";

const Home = () => {
  const [gamesData, setGamesData] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const screenWidth = useScreenWidth();
  const [authData, setAuthData] = useState({
    token: getToken(),
    accountId: getAccountId(),
  });

  const userToken = getToken();
  const gameId = getGameId();
  const palyerId = getAccountId();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const accountId = params.get("accountId");
    const gameId = params.get("gameId");
    const operator = params.get("operator");
    const gameServer = params.get("gameServer");
    const currency = params.get("currency");
    const gameMode = params.get("gameMode");
    const jurisdiction = params.get("jurisdiction");
    const locale = params.get("locale");

    if (token) {
      console.log("token from query params",token)
      setToken(token);
      setAuthData((prev) => ({ ...prev, token }));
    }
    if (accountId) {
      console.log("accountId from query params",accountId)
      setAccountId(accountId);
      setAuthData((prev) => ({ ...prev, accountId }));
    }
    if (gameId) setGameId(gameId);
    if (operator) setOperator(operator);
    if (gameServer) setGameServer(gameServer);
    if (currency) setCurrency(currency);
    if (gameMode) setGameMode(gameMode);
    if (jurisdiction) setJurisdiction(jurisdiction);
    if (locale) setLocale(locale);
  }, []);

  const handleGameForUser = async () => {
    const response = await getPublicGamesForUser(
      1,
      authData.accountId,
      authData.token
    );
    if (response?.games?.length > 0) {
      const sortedArray = response.games.sort((a, b) => b.pot - a.pot);
      setGamesData(sortedArray);
    }
  };
  const handleGameForPublic = async () => {
    const response = await getPublicGamesForPublic(
      1,
      authData.accountId,
      authData.token
    );
    if (response?.data?.games?.length > 0) {
      const sortedArray = response.data.games.sort((a, b) => b.pot - a.pot);
      setGamesData(sortedArray);
    }
  };

  useEffect(() => {
    if (authData.token && authData.accountId) {
      handleGameForUser();
      handleGameForPublic();
    }
  }, [authData]);
  const handleViewRuleButton = () => {
    setNavItem(4);
    navigate("/rules");
  };
  const handleJoinGameButton = () => {
    setNavItem(1);
    navigate("/game");
  };
  const handleCreatePrivateGame = () => {
    setNavItem(null);
    navigate("/privategame");
  };
  const handleHowToPlayButton = () => {
    document
      .getElementById("how-to-play")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // Lets other pages link straight to this section (e.g. the Games page's
  // "How To Play" button navigates to "/#how-to-play"). The #how-to-play
  // div sits above the lazy-loaded Suspense carousel, so it's already in the
  // DOM at first paint; the rAF just waits one frame for layout before
  // scrolling.
  useEffect(() => {
    if (location.hash === "#how-to-play") {
      requestAnimationFrame(() => {
        document
          .getElementById("how-to-play")
          ?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  }, [location.hash]);

  const gameSteps = [
    {
      step: "01",
      title: "Pick Your Team",
      description:
        "Choose one team you think will win their match. No odds. No bet slip. Every player pays the same entry. It all goes into one prize pot.",
      // No image: see import comment above.
    },
    {
      step: "02",
      title: "Win to Stay In",
      description:
        "Your team wins? You're through to the next round. They lose or draw? You're out. You can never pick the same team twice. Choose wisely.",
      image: HomeStep2,
    },
    {
      step: "03",
      title: "Survive to Win the Pot",
      description:
        "Reach the final 10% of players. You win a share of the pot. Outlast everyone and the rest of the pot is yours!",
      visual: <SurvivalTable />,
    },
  ];

  useEffect(() => {
    if (userToken) {
      var data = new FormData();
      data.append("event_name", "Home Page");
      sendMetaEvents(data);
    }
  }, []);

  return (
    <div>
      <div className="main-home">
        <div className="main-home-top-cont">
          <div className="black-background"></div>
          <BannerPromo
            handleJoinGameButton={handleJoinGameButton}
            events={gamesData}
            screenWidth={screenWidth}
          />
          <div className="main-home-top">
            <div>
              <div className="mobile-hide">
                <div className="intro-text font-cairo-extrabold line-height-44 custom-end">
                  <h1>GET IN THERE</h1>
                </div>
              </div>
              <div className="home-buttons home-desktoponly">
                <FilledButton
                  name={"Join a Game"}
                  btnClass="primary-background home-buttons-button "
                  type={screenWidth < 767 ? 1 : 2}
                  functionCall={handleJoinGameButton}
                />
                <SimpleFilledButton
                  name={"How to Play"}
                  btnClass={`lightgrey-background home-buttons-howtoplay btntype${
                    screenWidth < 767 ? 1 : 2
                  }`}
                  functionCall={handleHowToPlayButton}
                />
              </div>
            </div>
            <VideoPlayer src={IntroVideo} />
            <div className="home-buttons mobileonly">
              <FilledButton
                name={"Join a Game"}
                btnClass="primary-background home-buttons-button "
                type={screenWidth < 767 ? 1 : 2}
                functionCall={handleJoinGameButton}
              />
              <SimpleFilledButton
                name={"How to Play"}
                btnClass={`lightgrey-background home-buttons-howtoplay btntype${
                  screenWidth < 767 ? 1 : 2
                }`}
                functionCall={handleHowToPlayButton}
              />
            </div>
          </div>
        </div>
        <div className="main-home-bottom-cont">
          <div
            id="how-to-play"
            className="master-game primary-color font-cairo-medium primary-color"
          >
            HOW TO PLAY
          </div>
          <div className="how-play font-cairo-extrabold">
            One pick per round. Win or you're out. Last player standing takes
            the prize.
          </div>
          <Suspense fallback={<Loading />}>
            {screenWidth > 767 ? (
              <div className="home-steps extra-margins">
                {gameSteps.map((gameStep) => (
                  <GameStep
                    key={gameStep.step}
                    step={gameStep.step}
                    title={gameStep.title}
                    description={gameStep.description}
                    image={gameStep.image}
                    visual={gameStep.visual}
                  />
                ))}
              </div>
            ) : (
              <Carousel infinite={false}>
                {gameSteps.map((gameStep) => (
                  <GameStep
                    key={gameStep.step}
                    step={gameStep.step}
                    title={gameStep.title}
                    description={gameStep.description}
                    image={gameStep.image}
                    visual={gameStep.visual}
                  />
                ))}
              </Carousel>
            )}
          </Suspense>
          <div className="how-play-highlight background-blur">
            <div className="how-play-highlight-title font-cairo-extrabold">
              The pot is always won
            </div>
            <div className="how-play-highlight-body font-cairo-bold">
              Every game pays out its full prize pot. If the last players go
              out together, they split it.
            </div>
          </div>
          <div className="home-button-view-rules extra-margins">
            <FilledButton
              name={"View All Rules"}
              btnClass="primary-background home-buttons-read-all"
              type={1}
              functionCall={handleViewRuleButton}
            />
          </div>
          {gamesData?.length > 0 && (
            <>
              <div className="main-padding extra-margins">
                <div className="join-action font-cairo-medium primary-color">
                  JOIN THE ACTION NOW!
                </div>
                <div className="intro-text2 font-cairo-extrabold">
                  A glimpse into our most popular games!
                </div>
              </div>
              <div className="home-join-game-cont extra-margins">
                {gamesData
                  ? gamesData.map((item, index) => {
                      return <JoinGame gameDetails={item} key={index} />;
                    })
                  : null}
              </div>
            </>
          )}
          {/* <div className="home-view-button extra-margins">
            <FilledButton
              name={"View All Games"}
              link={"/game"}
              btnClass="primary-background home-buttons-read-all"
              type={1}
            />
          </div> */}
          <div className="news-padding">
            <HomeNews page={"home"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
